module.exports = __webpack_public_path__ + "img/elo.68a02c12.svg";